import { useEffect, useState } from 'react';
import { RoundedDialog, StandardDialogActions } from '../../../Global/Components';
import { DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { ListItemAvatar, ListItemText, InputAdornment } from '@mui/material';
import { List, ListItem, ListItemIcon, Avatar } from '@mui/material';
import UserManager from '../../../Global/UserManager';
import StateManager from '../../../Global/StateManager';
import axios from 'axios';
import { green, grey } from '@mui/material/colors';
import { SearchRounded, CheckCircleRounded, CheckCircleOutlineRounded } from '@mui/icons-material';

const SelectGroupsDialog = ({ open, onClose, onResult, initial }) => {
  const [groups, setGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [pattern, setPattern] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    UserManager.getGroupList()
      .then((res) => {
        setGroups(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  function addDeleteGroup(id) {
    let index = selectedGroups.indexOf(id);
    if (index > -1) {
      setSelectedGroups(selectedGroups.filter((x) => x !== id));
    } else {
      setSelectedGroups([...selectedGroups, id]);
    }
  }

  function done() {
    setSaving(true);
    const body = {
      users: initial,
      groups: selectedGroups,
    };
    axios
      .post('/admin/management/assignGroups', body)
      .then((res) => {
        setSaving(false);
        StateManager.setSuccessAlert('Groups has been assigned to the users');
        onResult(res.data);
        onClose();
        setSelectedGroups([]);
      })
      .catch((err) => {
        StateManager.setAxiosErrorAlert(err);
        setSaving(false);
      });
  }

  return (
    <RoundedDialog maxWidth="xs" fullWidth open={open} onClose={() => onClose(null)}>
      <DialogTitle>New Group</DialogTitle>
      <DialogContent>
        <Grid container sx={{ padding: '8px 0' }}>
          <TextField
            placeholder="Search group"
            fullWidth
            value={pattern}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchRounded sx={{ color: grey[300] }} />
                </InputAdornment>
              ),
            }}
            onChange={(event) => setPattern(event.target.value.toLowerCase())}
            variant="standard"
          />
        </Grid>
        <Grid container>
          <List sx={{ minHeight: '25vh', overflow: 'auto', width: '100%', marginTop: 1 }}>
            {groups
              .filter((grup) => grup.name.toLowerCase().includes(pattern))
              .map((group, i) => (
                <ListItem
                  key={group._id}
                  button
                  style={{ borderRadius: 5 }}
                  onClick={() => {
                    addDeleteGroup(group._id);
                    setPattern('');
                  }}
                >
                  <ListItemAvatar>
                    <Avatar>
                      {group.name?.charAt(0)}
                      {group.name?.charAt(1)}
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={group.name} />
                  <ListItemIcon sx={{ marginLeft: 'auto' }}>
                    {selectedGroups.includes(group._id) ? (
                      <CheckCircleRounded fontSize="large" sx={{ color: green[500] }} />
                    ) : (
                      <CheckCircleOutlineRounded fontSize="large" sx={{ color: grey[300] }} />
                    )}
                  </ListItemIcon>
                </ListItem>
              ))}
          </List>
        </Grid>
      </DialogContent>
      <StandardDialogActions saving={saving} onClose={() => onClose(null)} doneButtonText="SAVE" onDone={done} />
    </RoundedDialog>
  );
};

export default SelectGroupsDialog;
